import ProgressIndicatorIcon from "./ProgressIndicatorIcon";

export default ProgressIndicatorIcon;
